/**
 * Expected error types as below:
    - BAD_REQUEST
    - PASSWORD_REQUIREMENTS_NOT_MET
    - FACTOR_TYPE_NOT_SUPPORT
    - FORBIDDEN
    - USER_ALREADY_EXISTS
    - TOO_MANY_REQUESTS
    - INTERNAL_SERVER_ERROR
    - PROXY_ERROR
 * this function defines the base error code and error message returned by api, the message
 * can be overridden in each component by using it's own error mapping.
 */
export const mappingRegistrationAPIHttpError = (err) => {
  // for all the error types defined in registration api, refer to:
  let message = "";
  let errorType = err?.response?.data?.type;
  switch (errorType) {
    case "BAD_REQUEST":
      message = "The request is not well formed, please check again.";
      break;
    case "PASSWORD_REQUIREMENTS_NOT_MET":
      message =
        "Your password is not met our requirement, please try another one.";
      break;
    case "FACTOR_TYPE_NOT_SUPPORT":
      message = "The factor type is not supported.";
      break;
    case "FORBIDDEN":
      message = "You are not allowed to perform the action.";
      break;
    case "USER_ALREADY_EXISTS":
      message = "This email address is already in use.";
      break;
    case "TOO_MANY_REQUESTS":
      message =
        "You've tried this action too many times. Please try again in 1 hour.";
      break;
    case "INTERNAL_SERVER_ERROR":
      message =
        "We are experiencing errors in system, please try again after some time.";
      break;
    case "PROXY_ERROR":
      message =
        "Service is not available right now, please try again after some time.";
      break;
    default:
      errorType = "UNEXPECTED_ERROR";
      message =
        "We are experiencing errors in system, please try again after some time.";
      break;
  }
  const error = new Error(message);
  error.code = errorType;
  return error;
};
